// Volume-tier ATC pricing + "buy more to save" promo for site1 volume-tiers PDPs.
// Uses product.metafields.custom.volume_discount_tiers via ambrosiaPackVolumeDiscount.
function runSite1VolumeTiers() {
  const page = document.querySelector("product-page.site1_volume_tiers_pdp");
  if (!page) return;
  if (!page.querySelector(".cm-variant-qty")) return;

  function money(n) {
    return "$" + n.toFixed(2);
  }

  function getVolumeApi() {
    return window.ambrosiaPackVolumeDiscount || null;
  }

  function formatTierLabel(tier) {
    if (!tier) return "";
    const custom = tier.discount_label || tier.discountLabel;
    if (custom && String(custom).trim()) return String(custom).trim().toUpperCase();
    const pct = parseFloat(tier.percent);
    if (!pct || pct <= 0) return "";
    return "SAVE " + Math.round(pct) + "%";
  }

  function buildPromoMessage(totalQty, vol) {
    if (!vol || totalQty < 1) return "";

    const next = typeof vol.getNextTier === "function" ? vol.getNextTier(totalQty, page) : null;
    if (next) {
      const need = Math.max(1, parseInt(next.qty, 10) - totalQty);
      const label = formatTierLabel(next);
      if (!label) return "";
      if (need === 1) return "ADD 1 MORE BAG TO UNLOCK " + label + "!";
      return "ADD " + need + " MORE BAGS TO UNLOCK " + label + "!";
    }

    const active = typeof vol.getActiveTier === "function" ? vol.getActiveTier(totalQty, page) : null;
    if (active && parseFloat(active.percent) > 0) {
      return "GOOD! YOU'RE GETTING THE BEST DEAL!";
    }

    return "";
  }

  function updateAddToCartButtonText() {
    const qtyInputs = page.querySelectorAll(".cm-variant-qty");
    if (qtyInputs.length === 0) return;

    let totalQty = 0;
    const unitCents = [];
    const GLOBAL_DISCOUNT_FACTOR = window.GLOBAL_DISCOUNT_FACTOR || 1;

    qtyInputs.forEach(function (qtyInput) {
      const qty = parseInt(qtyInput.value, 10) || 0;
      totalQty += qty;

      const itemWrapper = qtyInput.closest(".cm-variant-item");
      if (itemWrapper && qty > 0) {
        const variantPriceAttr = itemWrapper.getAttribute("data-variant-price");
        if (variantPriceAttr) {
          const variantPrice = parseFloat(variantPriceAttr);
          const cents = Math.round(variantPrice * GLOBAL_DISCOUNT_FACTOR);
          for (let i = 0; i < qty; i++) unitCents.push(cents);
        }
      }
    });

    const retailCents = unitCents.reduce(function (sum, unit) {
      return sum + unit;
    }, 0);

    const vol = getVolumeApi();
    let discountedCents = retailCents;
    if (vol && unitCents.length) {
      if (typeof vol.computeOneTimeTotalCents === "function") {
        discountedCents = vol.computeOneTimeTotalCents(unitCents, totalQty, page);
      } else if (typeof vol.apply === "function") {
        discountedCents = vol.apply(retailCents, totalQty, page);
      }
    }

    const totalPrice = discountedCents / 100;
    const saveLabel =
      vol && typeof vol.getLabel === "function" ? vol.getLabel(totalQty, page) : "";

    const form = qtyInputs[0] ? qtyInputs[0].closest("form") : null;
    if (!form) return;

    const titleEls = page.querySelectorAll("[data-volume-title-price]");
    const atcPriceEl = page.querySelector("[data-volume-total-price]");

    if (totalQty > 0 && totalPrice > 0) {
      const totalText = money(totalPrice);
      titleEls.forEach(function (el) {
        el.textContent = totalText;
      });

      if (atcPriceEl) {
        atcPriceEl.textContent = saveLabel
          ? totalText + " (" + saveLabel + ")"
          : totalText;
        atcPriceEl.hidden = false;
      }
    } else {
      titleEls.forEach(function (el) {
        el.textContent = "";
      });
      if (atcPriceEl) {
        atcPriceEl.textContent = "";
        atcPriceEl.hidden = true;
      }
    }

    const buttonTextElements = form.querySelectorAll(
      ".cm-add-to-cart [data-js-product-add-to-cart-text]"
    );
    buttonTextElements.forEach(function (textEl) {
      if (!textEl.hasAttribute("data-original-text")) {
        textEl.setAttribute("data-original-text", textEl.textContent.trim());
      }
      textEl.textContent = textEl.getAttribute("data-original-text") || "Add to cart";
    });

    const addToCartBtn = form.querySelector(".cm-add-to-cart");
    if (addToCartBtn) {
      let promoLabel = form.querySelector("[data-volume-promo-label]");
      if (!promoLabel) {
        promoLabel = document.createElement("p");
        promoLabel.setAttribute("data-volume-promo-label", "");
        promoLabel.className = "volume-promo-label";
        promoLabel.style.cssText =
          "margin-top: 0.5em; margin-bottom: 0; font-weight: bold; text-transform: uppercase; text-align: center;";
        addToCartBtn.parentNode.insertBefore(promoLabel, addToCartBtn.nextSibling);
      }

      const promoText = buildPromoMessage(totalQty, vol);
      if (promoText) {
        promoLabel.textContent = promoText;
        promoLabel.style.display = "";
      } else {
        promoLabel.style.display = "none";
      }
    }
  }

  function preselectOrDefaultQty() {
    var formEl = page.querySelector("product-form[default-variant-id]");
    var FALLBACK_DEFAULT_VARIANT_ID = formEl
      ? formEl.getAttribute("default-variant-id")
      : null;

    var urlParams = new URLSearchParams(window.location.search);
    var paramId = urlParams.get("preselect");
    var PRESELECT_ID = paramId && /^\d+$/.test(paramId) ? paramId : null;

    function setQtyOneIfZeroByVariantId(variantId) {
      if (!variantId) return false;

      var item = page.querySelector(
        '.cm-variant-item[data-variant-id="' + variantId + '"]'
      );
      if (!item) return false;

      var qtyEl = item.querySelector(".cm-variant-qty");
      if (!qtyEl) return false;

      var curr = parseInt(qtyEl.value, 10) || 0;
      if (curr < 1) {
        qtyEl.value = "1";
        qtyEl.dispatchEvent(new Event("change", { bubbles: true }));
      }

      var container = item.closest(".cm-variants-grid");
      if (container && container.scrollWidth > container.clientWidth) {
        var itemLeft = item.offsetLeft;
        var itemRight = item.offsetLeft + item.offsetWidth;
        var viewLeft = container.scrollLeft;
        var viewRight = container.scrollLeft + container.clientWidth;
        var nextScrollLeft = container.scrollLeft;
        if (itemLeft < viewLeft) nextScrollLeft = itemLeft;
        else if (itemRight > viewRight)
          nextScrollLeft = (itemRight - container.clientWidth) * 10;
        container.scrollTo({ left: nextScrollLeft, behavior: "smooth" });
      }
      return true;
    }

    if (PRESELECT_ID && setQtyOneIfZeroByVariantId(PRESELECT_ID)) return;
    setQtyOneIfZeroByVariantId(FALLBACK_DEFAULT_VARIANT_ID);
  }

  function syncGalleryToVariant(qtyInput) {
    var qty = parseInt(qtyInput.value, 10) || 0;
    if (qty <= 0) return;
    var item = qtyInput.closest(".cm-variant-item");
    if (!item) return;
    var src = item.getAttribute("data-alt-img");
    if (!src) {
      var img = item.querySelector("img");
      src = img && (img.currentSrc || img.src);
    }
    if (!src) return;

    var slider =
      page.querySelector(".product-gallery css-slider") ||
      page.querySelector("css-slider");
    if (!slider || !slider.changeSlide) return;

    var slug = src.split("/").pop().split("?")[0];
    var slides = slider.querySelectorAll(".product-gallery-item");
    var targetIndex = -1;
    for (var i = 0; i < slides.length; i++) {
      var slideImg = slides[i].querySelector("img");
      var s = (slideImg && (slideImg.currentSrc || slideImg.src)) || "";
      if (s.indexOf(slug) !== -1) {
        targetIndex = parseInt(slides[i].getAttribute("data-index"), 10);
        if (isNaN(targetIndex)) targetIndex = i;
        break;
      }
    }
    if (targetIndex >= 0 && slider.sliderEnabled) {
      slider.changeSlide(targetIndex, "auto");
    }
    if (targetIndex >= 0 && window._site1Thumbs && slug) {
      var slideEls = document.querySelectorAll("#thumbnail-slider .splide__slide");
      for (var j = 0; j < slideEls.length; j++) {
        var si = slideEls[j].querySelector("img");
        if (si && (si.currentSrc || si.src).indexOf(slug) !== -1) {
          window._site1Thumbs.go(j);
          break;
        }
      }
    }
  }

  var leftThumbs = page.querySelector("#thumbnail-slider");
  if (leftThumbs) {
    leftThumbs.addEventListener("click", function (e) {
      var slide = e.target.closest("#thumbnail-slider .splide__slide");
      if (!slide) return;
      var slider =
        page.querySelector(".product-gallery css-slider") ||
        page.querySelector("css-slider");
      if (!slider || !slider.sliderEnabled || !slider.changeSlide) return;
      var slides = leftThumbs.querySelectorAll(".splide__slide");
      var idx = -1;
      for (var t = 0; t < slides.length; t++) {
        if (slides[t] === slide) {
          idx = t;
          break;
        }
      }
      if (idx >= 0) slider.changeSlide(idx, "auto");
    });
  }

  page.querySelectorAll(".cm-variant-qty").forEach(function (qtyInput) {
    qtyInput.addEventListener("change", function () {
      updateAddToCartButtonText();
      syncGalleryToVariant(qtyInput);
    });
  });

  preselectOrDefaultQty();
  setTimeout(function () {
    preselectOrDefaultQty();
    var qtyInputs = page.querySelectorAll(".cm-variant-qty");
    for (var i = 0; i < qtyInputs.length; i++) {
      if (parseInt(qtyInputs[i].value, 10) > 0) {
        syncGalleryToVariant(qtyInputs[i]);
        break;
      }
    }
  }, 150);
  setTimeout(function () {
    var qtyInputs = page.querySelectorAll(".cm-variant-qty");
    for (var j = 0; j < qtyInputs.length; j++) {
      if (parseInt(qtyInputs[j].value, 10) > 0) {
        syncGalleryToVariant(qtyInputs[j]);
        break;
      }
    }
  }, 400);
  setTimeout(updateAddToCartButtonText, 450);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runSite1VolumeTiers);
} else {
  runSite1VolumeTiers();
}
